import { useQuery } from '@tanstack/react-query';
import type { Dayjs } from 'dayjs';
import { requestApiGetConjunctions } from './useQueryCdm';
import { AdvancedSearchParamsType, SortType } from '@/types';

const useQueryKorSat = (sort: SortType | undefined, baseDate: Dayjs) => {
  const today = baseDate.utc().startOf('day').subtract(1, 'day');
  const collectionName = `SPACEMAP_CA_${today.format('YYYYMMMDD').toUpperCase()}T0000_S1`;
  return useQuery({
    queryKey: ['korean-satellites-conjunctions-daily', sort, today.format('YYYY-MM-DD')],
    queryFn: async () => {
      const params: AdvancedSearchParamsType = {
        limit: 100,
        page: 0,
        country: 'SKOR',
        order: 'ASC',
        sort,
      };

      const result = await requestApiGetConjunctions(params, collectionName);

      return {
        conjunctions: result.conjunctions,
        totalCount: result.totalCount,
      };
    },
  });
};

export default useQueryKorSat;
